module.exports = __webpack_public_path__ + "media/images/samples/home/news/n2@2x-328f1938812246356d6eed9df9a37849.png";